import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom'
import AppWrapper from './AppWrapper';
import { PrimeReactProvider } from 'primereact/api';
import { primeConfig } from './primeConfig';
import { ToastProvider } from './context/ToastContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PrimeReactProvider value={primeConfig}>
        <HashRouter>
            <ToastProvider>
                <AppWrapper />
            </ToastProvider>
        </HashRouter>
    </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
